<script>
  import { decimal } from '@/utils/i18n';

  export default {
    props: {
      /**
       * Batch results containing THC, THCa, CBD, etc.
       */
      batchResults: {
        type: [Object, null],
        default: () => ({}),
      },

      cannabinoidUnit: {
        type: String,
        default: '',
      },

      /**
       * Certificate of Analysis batch documents
       */
      documents: {
        type: Array,
        default: () => [],
      },
    },

    methods: { decimal },
  };
</script>

<template>
  <div>
    <!-- COA Documents  -->
    <div v-for="document in documents" class="ll-grid ll-grid-cols-2 ll-my-1" :key="document.id">
      <span class="font-weight-bold">{{ $t('common.coa') }}</span>
      <a v-if="documents.length" class="text-right ll-pr-2" target="_blank" :href="document.document">
        {{ $t('common.viewDocument') }}
      </a>
    </div>

    <!-- Batch Results -->
    <div
      v-for="(result, name, resultIndex) in batchResults"
      class="ll-grid ll-grid-cols-2 ll-my-1"
      :data-test="`div|batch-info-${name}`"
      :key="`result-${resultIndex}`"
    >
      {{ $t(`common['${name}']`) }}
      <span class="text-right text-lowercase ll-pr-2"> {{ decimal(result) }} {{ cannabinoidUnit }} </span>
    </div>
  </div>
</template>
